import React, { useState, useEffect } from "react";
import { useHttpClient } from "../../../../shared/hooks/http-hook";
import FiltrosRelatorio from "../ui/filtrosRelatorio/FiltrosRelatorio";
import RelatorioCredenciais from "./components/RelatorioCredenciais";
import RelatorioAprovacoesOrcamentos from "./components/RelatorioAprovacoesOrcamentos";
import "./RelatoriosOrcamentos.scss";
import RelatorioPesquisaOrcamentos from "./components/RelatorioPesquisaOrcamentos";
import RelatorioOrcamentosAltoRisco from "./components/RelatorioOrcamentosAltoRisco";
import RelatorioOrcamentosSemAgendamento from "./components/RelatorioOrcamentosSemAgendamento";

const tiposRelatorios = [
  { value: "", label: "Selecione um relatório" },
  { value: "pesquisaOrcamentos", label: "Relatório de Pesquisa" },
  { value: "credenciais", label: "Relatório de Credenciais" },
  {
    value: "orcamentosAltoRisco",
    label: "Orçamentos de Alto Risco",
  },
  {
    value: "orcamentosSemAgendamento",
    label: "Clientes com Orçamento que não Voltaram",
  },
  // { value: "aprovacoes", label: "Relatório de Aprovações de Orçamentos" },
  // Adicione mais tipos de relatórios aqui conforme necessário
];

// Definição de quais relatórios suportam quais ações
const relatorioCaps = {
  credenciais: { gerar: true, exportar: false },
  aprovacoes: { gerar: true, exportar: true },
  pesquisaOrcamentos: { gerar: true, exportar: true },
  orcamentosAltoRisco: { gerar: true, exportar: true },
  orcamentosSemAgendamento: { gerar: true, exportar: true },
  // Configure as capacidades para outros relatórios aqui
};

function RelatoriosOrcamentos({ auth, clinica, gerarPdfComprovativoDesconto }) {
  const { sendRequest } = useHttpClient();
  const [dadosRelatorio, setDadosRelatorio] = useState({
    open: "",
    dataFiltro: {},
    acao: "",
    //Contador para forçar a atualização
    atualizacoes: 0,
  });

  // Unidades da clínica e a escolhida. Vazio = consolidado da empresa; em
  // clínicas de unidade única a lista fica vazia e o seletor nem aparece.
  const [unidades, setUnidades] = useState([]);
  const [unidadeSelecionada, setUnidadeSelecionada] = useState("");

  useEffect(() => {
    // Só faz sentido oferecer a escolha quando a clínica tem mesmo mais do que
    // uma unidade — nas outras nem se pede a lista.
    if (!clinica?.clinica?.multiEstabelecimento) return;

    const fetchUnidades = async () => {
      try {
        const resposta = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/estabelecimentos/clinica/${clinica.clinica._id}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        );
        setUnidades(resposta.estabelecimentos || []);
      } catch (err) {
        console.error("err", err);
      }
    };
    fetchUnidades();
  }, [
    sendRequest,
    auth.token,
    clinica?.clinica?._id,
    clinica?.clinica?.multiEstabelecimento,
  ]);

  const gerarRelatorioHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) {
      // Alerta se nenhum tipo de relatório for selecionado
      return;
    }

    setDadosRelatorio((prevState) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial: dataInicial, dataFinal: dataFinal },
      acao: "gerar",
      atualizacoes: prevState.atualizacoes + 1,
    }));
  };

  const exportarFicheiroHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) {
      // Alerta se nenhum tipo de relatório for selecionado
      return;
    }

    setDadosRelatorio((prevState) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial: dataInicial, dataFinal: dataFinal },
      acao: "exportar",
      atualizacoes: prevState.atualizacoes + 1,
    }));
  };

  // Função auxiliar para renderizar o componente de relatório correto
  const renderizarRelatorio = () => {
    const { open, dataFiltro, acao, atualizacoes } = dadosRelatorio;

    if (!open) return null;

    const props = {
      dataFiltro: dataFiltro,
      dadosClinica: clinica.clinica,
      auth: auth,
      acao: acao, // Passa a ação para o componente
      atualizacoes: atualizacoes,
      // Unidade escolhida (vazio = consolidado) e a lista, para o relatório
      // filtrar e identificar de que unidade são os dados.
      unidadeSelecionada: unidadeSelecionada,
      unidades: unidades,
    };

    switch (open) {
      case "credenciais":
        return (
          <RelatorioCredenciais
            {...props}
            gerarPdfComprovativoDesconto={gerarPdfComprovativoDesconto}
          />
        );
      case "aprovacoes":
        return <RelatorioAprovacoesOrcamentos {...props} />;
      case "pesquisaOrcamentos":
        return <RelatorioPesquisaOrcamentos {...props} />;
      case "orcamentosAltoRisco":
        return <RelatorioOrcamentosAltoRisco {...props} />;
      case "orcamentosSemAgendamento":
        return <RelatorioOrcamentosSemAgendamento {...props} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <FiltrosRelatorio
        tiposRelatorios={tiposRelatorios}
        gerarRelatorioHandler={gerarRelatorioHandler}
        exportarFicheiroHandler={exportarFicheiroHandler}
        relatorioCaps={relatorioCaps} // Passar as capacidades para potencialmente desabilitar botões
        // Manter o tipo de relatório selecionado
        relatorioSelecionado={dadosRelatorio.open}
        unidades={unidades}
        unidadeSelecionada={unidadeSelecionada}
        onUnidadeChange={setUnidadeSelecionada}
        relatoriosComUnidade={["credenciais"]}
      />

      {renderizarRelatorio()}
    </div>
  );
}

export default RelatoriosOrcamentos;
